import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environment/environment';

export const authConfig: AuthConfig = {
  issuer: environment.keycloak.issuer,
  redirectUri: environment.keycloak.redirectUri,
  postLogoutRedirectUri: environment.keycloak.logoutRedirectUri,
  clientId: environment.keycloak.clientId,
  scope: 'openid dashboard-roles',
  responseType: 'code',
  requireHttps: false,
  strictDiscoveryDocumentValidation: false,
};
